import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { CLIENT_NAV, Icon } from '@getpay93/ui';
import { useAuth } from '../auth/AuthContext';
import { OrgSwitcherClient } from './cliente/OrgSwitcherClient';
import { Inicio } from './cliente/Inicio';
import { Pagos } from './cliente/Pagos';
import { Perfil } from './cliente/Perfil';

export function ClientArea() {
  const { logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const seg = loc.pathname.replace(/^\/app\/?/, '').split('/')[0] || 'inicio';
  const active = CLIENT_NAV.some((n) => n.id === seg) ? seg : 'inicio';

  return (
    <div style={{ minHeight: '100%', display: 'flex', flexDirection: 'column', maxWidth: 640, margin: '0 auto', background: 'var(--bg)' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid var(--border)' }}>
        <OrgSwitcherClient />
        <button onClick={logout} style={{ background: 'transparent', border: 'none', color: 'var(--text-faint)', cursor: 'pointer', fontFamily: 'var(--font-sans)' }}>Salir</button>
      </header>
      <main style={{ flex: 1, padding: 20 }}>
        <Routes>
          <Route index element={<Inicio />} />
          <Route path="pagos" element={<Pagos />} />
          <Route path="perfil" element={<Perfil />} />
          <Route path="*" element={<Inicio />} />
        </Routes>
      </main>
      <nav style={{ display: 'flex', borderTop: '1px solid var(--border)', background: 'var(--surface)', position: 'sticky', bottom: 0 }}>
        {CLIENT_NAV.map((n) => {
          const on = n.id === active;
          return (
            <button key={n.id} onClick={() => nav(n.to ?? '/app')} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, padding: '10px 0', background: 'transparent', border: 'none', cursor: 'pointer', color: on ? 'var(--brand-green)' : 'var(--text-faint)', fontFamily: 'var(--font-sans)', fontSize: 11, fontWeight: on ? 700 : 600 }}>
              <Icon name={n.icon} size={22} />
              {n.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
